/**
 * This is purposefully kept separate since multiselect filters will be enabled in future.
 * Intentionally the flagsmith is not used here as it can be overhead
 *
 * When We decide to enable multiselect filters for Control Tower, just set the flag to true or remove the flag entirely from line 8 and 18
 *  */
const ENABLE_CT_MULTISELECT_FILTERS = false;

// Helper function to handle array values
const handleArrayValue = (filterKey: string, key: string, value: any[]) => {
  return {
    filterKey,
    label: ENABLE_CT_MULTISELECT_FILTERS ? key : value[0],
    value: ENABLE_CT_MULTISELECT_FILTERS ? value.map((item) => ({ label: item, value: item })) : value[0],
    filterType: "panel-filters",
    filterLabel: key
  };
};
// Helper function to handle range objects with from/to properties
const handleRangeObject = (filterKey: string, key: string, value: any, transformedFilters: Record<string, any>) => {
  if (value.from) {
    const fromKey = `${filterKey}From`;
    transformedFilters[fromKey] = {
      filterKey: fromKey,
      label: value.from,
      value: value.from,
      filterType: "panel-filters",
      filterLabel: `${key} From`
    };
  }
  if (value.to) {
    const toKey = `${filterKey}To`;
    transformedFilters[toKey] = {
      filterKey: toKey,
      label: value.to,
      value: value.to,
      filterType: "panel-filters",
      filterLabel: `${key} To`
    };
  }
};

// Helper function to handle string values
const handleStringValue = (filterKey: string, key: string, value: string) => {
  return {
    filterKey,
    label: value,
    value: value,
    filterType: "panel-filters",
    filterLabel: key
  };
};

// Converts filter payload received from API to the format used in filters store
export const filterPayloadConverter = (filters: Record<string, any>) => {
  // Add null/undefined check
  if (!filters || typeof filters !== "object") {
    console.warn("filterPayloadConverter received invalid input:", filters);
    return {};
  }

  const transformedFilters: Record<string, any> = {};

  for (const [key, value] of Object.entries(filters)) {
    const filterKey = key.toLowerCase();

    if (Array.isArray(value)) {
      transformedFilters[filterKey] = handleArrayValue(filterKey, key, value);
    } else if (typeof value === "object" && value !== null && Object.keys(value).length > 0) {
      if (value.from !== undefined || value.to !== undefined) {
        handleRangeObject(filterKey, key, value, transformedFilters);
      }
    } else if (typeof value === "string" && value.trim() !== "") {
      transformedFilters[filterKey] = handleStringValue(filterKey, key, value);
    }
  }

  return transformedFilters;
};

// Converts filters from the filters store to the payload format expected by the API
export const convertFilterForPayload = (filters: any) => {
  const data = Object.entries(filters).reduce(
    (acc, [key, filter]: [string, any]) => {
      const filterKey = filter.filterKey || key;

      // Handle date range filters specially
      if (filterKey.toLowerCase().endsWith("from") || filterKey.toLowerCase().endsWith("to")) {
        const baseKey = filterKey
          .toLowerCase()
          .replace(/(from|to)$/, "")
          .toLowerCase();
        const rangeKey = filterKey.toLowerCase().endsWith("from") ? "from" : "to";

        // Initialize the date range object if it doesn't exist
        if (!acc[baseKey]) {
          acc[baseKey] = {};
        }

        // Convert date to ISO string format and add to range
        if (filter?.value) {
          const dateValue = new Date(filter.value);
          acc[baseKey][rangeKey] = dateValue.toISOString();
        }
      }
      // Handle regular filters
      else if (Array.isArray(filter?.value)) {
        const values = filter.value.map((item: any) => item.value || item);
        acc[filterKey] = values;
      } else if (filter?.value) {
        acc[filterKey] = [filter.value];
      }
      return acc;
    },
    {} as Record<string, any>
  );
  return data;
};
